module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("l81gE"))).then(() => parcelRequire('cvs7o'));